import { createContext, useContext, useState, useCallback } from 'react';

const HeartContext = createContext();

export const useHeart = () => {
  const context = useContext(HeartContext);
  if (!context) {
    throw new Error('useHeart must be used within HeartProvider');
  }
  return context;
};

export const HeartProvider = ({ children }) => {
  const [submission, setSubmission] = useState({
    pseudo: '',
    email: '',
    heartNumber: null,
    closePhotoPath: null,
    contextPhotoPath: null,
    latitude: null,
    longitude: null,
    locationName: '',
  });
  
  const [lastResult, setLastResult] = useState(null);

  const updateSubmission = useCallback((updates) => {
    setSubmission(prev => ({ ...prev, ...updates }));
  }, []);

  const resetSubmission = useCallback(() => {
    setSubmission({
      pseudo: '',
      email: '',
      heartNumber: null,
      closePhotoPath: null,
      contextPhotoPath: null,
      latitude: null,
      longitude: null,
      locationName: '',
    });
    setLastResult(null);
  }, []);

  return (
    <HeartContext.Provider value={{
      submission,
      updateSubmission,
      resetSubmission,
      lastResult,
      setLastResult
    }}>
      {children}
    </HeartContext.Provider>
  );
};
